import React from 'react';
import './FeaturedProductCard.scss';
import ProductSummary from '../../../../ProductSummary/ProductSummary';

/**
 *
 * @param {object} product
 * @param {string} starsAssetUrl
 * @param {boolean} showRating
 * @param {boolean} showPrice
 * @param {boolean} isLinked
 * @param {boolean} enablePreorder
 * @returns {JSX.Element}
 * @constructor
 */
const FeaturedProductCard = ({
  product,
  starsAssetUrl,
  showRating,
  showPrice,
  isLinked,
  enablePreorder,
}) => (
  <div className="c-featured-product-card">
    <ProductSummary
      product={product}
      starsAssetUrl={starsAssetUrl}
      isHeroProductListing={false}
      showRating={showRating}
      isLinked={isLinked}
      enablePreorder={enablePreorder}
      showPrice={showPrice}
    />
  </div>
);

export default FeaturedProductCard;
